import { backendApi } from "@/services/backend/api";
import {
  DeleteRequest,
  Documentation,
  DocumentationList,
  GetRequest,
  ListRequest,
  PutRequest,
} from "@/services/backend/qpm/documentation/types/documentation";

const qpmDocumentationServiceApi = backendApi
  .enhanceEndpoints({
    addTagTypes: ["QpmDocumentation"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      qpmDocumentationAdd: build.mutation<Documentation, PutRequest>({
        query: (request) => ({
          url: `/qpm/documentation`,
          method: "POST",
          body: request,
        }),
        invalidatesTags: ["QpmDocumentation"],
      }),
      qpmDocumentationGet: build.query<Documentation, GetRequest>({
        query: (request) => ({
          url: `/qpm/documentation`,
          method: "GET",
          params: request,
        }),
        providesTags: (result) =>
          result ? [{ type: "QpmDocumentation", id: result.id }] : [],
      }),
      qpmDocumentationList: build.query<DocumentationList, ListRequest>({
        query: () => ({
          url: `/qpm/documentation/list`,
          method: "GET",
        }),
        providesTags: (result) =>
          result ? [{ type: "QpmDocumentation", id: "LIST" }] : [],
      }),
      qpmDocumentationDelete: build.mutation<null, DeleteRequest>({
        query: (request) => ({
          url: `/qpm/documentation`,
          method: "DELETE",
          body: request,
        }),
        invalidatesTags: (result, error, { id }) => [
          { type: "QpmDocumentation", id: "LIST" },
          { type: "QpmDocumentation", id },
        ],
      }),
    }),
  });

export const {
  useQpmDocumentationAddMutation,
  useQpmDocumentationGetQuery,
  useQpmDocumentationListQuery,
  useQpmDocumentationDeleteMutation,
} = qpmDocumentationServiceApi;
